import React from 'react';
import Image from '../../../common/components/UI/Image'
import styles from '@/styles/helper-actions.module.scss';
import { activatePlanClicked, serviceRequestClicked } from '../../../../tracking/segment/header';
import { useRouter } from 'next/router';
import { isMobile } from 'react-device-detect';

const HelperActions = () => {
  const router = useRouter();

  const serviceRequestHandler = () => {
    serviceRequestClicked();
    router.push('/account/plans');
  };

  const activatePlanHandler = () => {
    activatePlanClicked();
    router.push('/account/activation');
  };

  return (
    <div className={styles.helperActions}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h2 className={styles.title}>Manage Your Device & Plan</h2>
        </div>

        {isMobile? (
          <div className={styles.mobileButtons}>
            <button className={styles.mobileButton} onClick={serviceRequestHandler}>
              <div className={styles.mobileIconWrapper}>
                <Image
                  src="/static/images/fix_tool.gif"
                  alt="Fix Tool"
                  width={24}
                  height={24}
                />
              </div>
              <div className={styles.mobileButtonText}>
              SERVICE REQUEST
              </div>
            </button>

            <button className={styles.mobileButton} onClick={activatePlanHandler}>
              <div className={styles.mobileIconWrapper}>
                <Image
                  src="/static/images/arrow-rounded.gif"
                  alt="Arrow Rounded"
                  width={24}
                  height={24}
                />
              </div>
              <div className={styles.mobileButtonText}>
              ACTIVATE PLAN
              </div>
            </button>
          </div>
        ) : (
          <div className={styles.container}>
            <div className={styles.item} onClick={serviceRequestHandler}>
              <div className={styles.itemContent}>
                <div className={styles.iconWrapper}>
                  <Image
                    src="/static/images/fix_tool.gif"
                    alt="Fix Tool"
                    width={45}
                    height={45}
                  />
                </div>
                <button className={styles.itemButton}>SERVICE REQUEST</button>
              </div>
            </div>

            <div className={styles.item} onClick={activatePlanHandler}>
              <div className={styles.itemContent}>
                <div className={styles.iconWrapper}>
                  <Image
                    src="/static/images/arrow-rounded.gif"
                    alt="Arrow Rounded"
                    width={45}
                    height={45}
                  />
                </div>
                <button className={styles.itemButton}>ACTIVATE PLAN</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HelperActions;
